import React from 'react';
import { classNames } from '../../utils/format';

export default function StatCard({ label, value, change, changeTone = 'success', icon, tone = 'sc1' }) {
  return (
    <div className={classNames('stat-card', tone)}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {change && (
        <div className={classNames('stat-change', changeTone === 'warn' && 'warn')}>{change}</div>
      )}
      {icon && <div className="stat-icon">{icon}</div>}
    </div>
  );
}
